<div id="manageamp" class="subBlockContainer managesubscriptiondetails">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <div class="subBlockContent">
    <div class="title-wrapper">
      <!-- <img class="page-title-img" [src]="details?.annuityType?.logo"> -->
    </div>
    <div class="item-title-wrapper">
      <mat-accordion multi>
        <!-- Customer Details -->
        <mat-expansion-panel expanded="true" *ngIf="showCustomerDetail">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text"> CUSTOMER DETAILS </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text">CUSTOMER NAME:&nbsp; </span><span>{{ details?.customer?.company_name }}</span>
              <span class="highlight-text"> | CUSTOMER ID:&nbsp; </span><span>{{ details?.customer?.customer_id }}</span>
              <span class="highlight-text"> | STATUS:&nbsp; </span><span>{{ annuity?.status == "Sent Association" ? "Pending Transfer" : (annuity?.status || 'ACTIVE') }}</span>
              <mat-spinner
                *ngIf="isAMPTenantDetailLoading"
                mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading"
                diameter="20"
              >
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <dd-amp-customer-details [details]="details"></dd-amp-customer-details>
        </mat-expansion-panel>

        <!-- Subscriptions -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              <span>
                SUBSCRIPTION
              </span>
            </mat-panel-title>          
          
            <mat-panel-description>             
                <button class="button button-red button-round" style="margin-left: 680px;
                          float: right;" *ngIf="ampSubs?.length"                         
                          (click)="downloadRenewalPreview('Indicative Renewal_'+ details?.customer.customer_id,$event, details?.customer)" (click)="$event.stopPropagation()">
                  Download Renewal Preview
                </button>              
            </mat-panel-description>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text"> {{ ampSubs?.length ? ampSubs.length : "0" }} Subscription(s) </span>
              <mat-spinner
                *ngIf="isAMPItemLoading"
                mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading"
                diameter="20"
              >
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div style="font-size: 12px;">
            <div class="panel-body">
              <!-- <div style="display: flex;">
                <app-refresh-button
                  style="margin-left: auto;"
                  [spinnerRotate]="isAMPItemLoading"
                  (refreshCallBack)="fetchAMPItemsView()"
                ></app-refresh-button>
              </div> -->

              <div class="row filter-wrapper" style="margin-bottom: 40px;" >
                <ng-container *ngIf="!isEligibleOffersLoading && eligibleOffers?.length">
                  <div class="col-sm-auto" style="padding-right: 7px;">
                    <span class="DDRed highlight-text">
                      High Growth Offers
                    </span>
                  </div>
                  <div>
                    <button
                      class="button button-red button-round button-mid"
                      (click)="viewHighGrowthRenewals()"
                    >
                      Learn More
                    </button>
                  </div>                 
                </ng-container>

                <mat-spinner *ngIf="isEligibleOffersLoading"
                  mode="indeterminate"
                  class="circle"
                  style="margin-left: 20px;"
                  diameter="20"
                  >
                </mat-spinner>               
              </div>
              <div *ngIf="ampSubs?.length && !isAMPItemLoading">
                <!-- <h6 class="red-text nce-migration-indicator" *ngIf="details?.customer?.out_status == 'SY'">
                  Subscription refresh in progress
                </h6> -->

                <div class="mTable-header">
                  <div class="row filter-wrapper">
                    <div class="col-md-3" style="padding-bottom: 1.25em;">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" 
                          (keyup)="applySubListFilter($event)">
                      </div>
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div>
                <div class="mTable">
                  <div *ngIf="ampSubs?.length">
                    <table class="table" mat-table [dataSource]="ampSubsTableDataSource" style="margin-bottom: unset;">
                      <!-- Desc Column -->
                      <ng-container matColumnDef="desc">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style = "text-align: left;"> DESCRIPTION </th>
                        <td class="push-left-75 table-cell" mat-cell *matCellDef="let sub">
                          <ng-container>
                            <div matTooltip="{{sub?.out_stk_description}}" class="description">
                              <span [ngClass]="{'grey-out': !showing(sub) }">{{ sub?.out_stk_description }}</span>
                            </div>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- Expiry Date Column -->
                      <!-- <ng-container matColumnDef="expiryDate">
                        <th 
                          mat-header-cell *matHeaderCellDef
                          class="table-cell" 
                          style="text-align: center; white-space: nowrap;" 
                        > 
                          EXPIRY DATE 
                        </th>
                        <td mat-cell *matCellDef="let sub;" style="text-align: center;" class="align-top table-cell">
                          <span> {{ sub?.out_expiry_date }} </span>
                        </td>
                      </ng-container> -->

                      <!-- QTY Column -->
                      <ng-container matColumnDef="qty">
                        <th
                          *matHeaderCellDef
                          mat-header-cell
                          class="table-cell"
                          style="text-align: right;"
                        >
                          QTY
                        </th>
                        <td mat-cell *matCellDef="let sub;" class="align-top table-cell" style="text-align: right;">
                          <ng-container>
                            <span [ngClass]="{'grey-out': !showing(sub) }"> {{ sub?.out_confirmed_qty | number: '1.0-0' }} </span>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- USED QTY Column -->
                      <ng-container matColumnDef="usedQty">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style="text-align: right;">
                          USED QTY
                        </th>
                        <td mat-cell *matCellDef="let sub;" class="align-top table-cell" style="text-align: right;">
                          <ng-container *ngIf="showing(sub)">
                            <span> {{ sub?.out_used_qty | number: '1.0-0' }} </span>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- RRP Column -->
                      <ng-container matColumnDef="rrp">
                        <th *matHeaderCellDef mat-header-cell class="table-cell" style="text-align: right;">
                          <span>RRP</span> 
                        </th>
                        <td mat-cell *matCellDef="let sub;" class="push-left-75 table-cell" style="text-align: right;">
                          <ng-container *ngIf="showing(sub)">
                            <div>
                              <span>{{ sub?.out_rrp | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                            </div>
                            <div>
                              <span>{{ getRRPTotal(sub) | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                            </div>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- Price Column -->
                      <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style="text-align: right;"> PRICE </th>
                        <td 
                          mat-cell
                          *matCellDef="let sub;"
                          class="push-left-75 table-cell"
                          style="text-align: right;"
                          
                        >
                          <ng-container *ngIf="showing(sub)">
                            <div>
                              <span>{{ sub?.out_price | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                            </div>
                            <div>
                              <span >
                                {{ sub?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}
                              </span>
                            </div>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- AutoRenew Column -->
                      <ng-container matColumnDef="autoRenew">
                        <th mat-header-cell *matHeaderCellDef  class="table-cell" style="text-align: right;"> AUTO RENEW
                        </th>
                        <td mat-cell *matCellDef="let sub" style="text-align: right;">
                          <ng-container *ngIf="showing(sub)">
                            <span>
                              {{ sub?.out_auto_renew == 'Y' ? 'Yes' : 'No' }}
                            </span>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- ScheduledRenewalQty Column -->
                      <ng-container matColumnDef="scheduledRenewalQty">
                        <th mat-header-cell *matHeaderCellDef  class="table-cell" style="text-align: right;" width="10%"> SCHEDULED RENEWAL QTY
                        </th>
                        <td mat-cell *matCellDef="let sub;" class="align-top table-cell" style="text-align: right;">
                          <ng-container *ngIf="showing(sub)">
                            <span> {{ sub?.out_qty | number: '1.0-0' }} </span>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- Status Column -->
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style="text-align: center;"> STATUS </th>
                        <td mat-cell *matCellDef="let sub;" class="push-left-75 table-cell" style="text-align: center;">
                          <ng-container>
                            <div>
                              <span [ngClass]="{'grey-out': !showing(sub) }">
                                {{ sub?.out_status_desc }}
                              </span>
                              <br />
                              <mat-icon class="DDRed" placement="bottom" *ngIf="sub?.out_status_desc == 'Error'"
                                ngbTooltip="{{sub?.out_error_message}}">
                                info
                              </mat-icon>
                            </div>
                          </ng-container>
                        </td>
                      </ng-container>

                      <!-- Manage Button Column -->
                      <ng-container matColumnDef="manageBtn">
                        <th mat-header-cell *matHeaderCellDef width="5%" class="table-cell"></th>
                        <td mat-cell *matCellDef="let sub;" class="align-center table-cell">
                          <ng-container *ngIf="showing(sub)">
                            <button
                              class="button button-red button-round"
                              (click)="manageAMPSubscription(sub)"> {{ authService?.currentUserHasPurchaseAccess() ? 'Manage' : 'View' }}
                            </button>
                          </ng-container>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <!-- table footer -->
                    <!-- <div class="row totalPrice-wrapper">
                        <div class="col align-center">
                            <span><b>Active Total (Ex GST) </b>
                                <span class="activeTotal">{{activeTotal |
                                    currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                        </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col button-center" style="margin-bottom: 20px;">
                  <button 
                    [disabled]="isAMPItemLoading || disableBuyButton"
                    [matTooltipDisabled]="!disableBuyButton"
                    matTooltip="Anniversary date is fast approaching"
                    class="button button-red button-large button-center-left"
                    (click)="goToAMPProductList('ENTERPRISE');"
                  >
                    Add New Enterprise Product
                  </button>
                </div>
                <div class="col button-center" style="margin-bottom: 20px;">
                  <button
                    [disabled]="isAMPItemLoading || disableBuyButton"
                    [matTooltipDisabled]="!disableBuyButton"
                    matTooltip="Anniversary date is fast approaching"
                    class="button button-red button-large button-center-left"
                    (click)="goToAMPProductList('TEAMS');"
                  >
                    Add New Teams Product
                  </button>
                </div>

                <div class="col button-center" style="margin-bottom: 20px;" *ngIf="showRenewNow()">
                  
                  <button
                    [disabled]="loadingPreview"
                    class="button button-red button-large button-center-left"
                    (click)="renewNow()"
                  >
                    Renew Now
                  </button>
                  <mat-spinner
                    *ngIf="loadingPreview"
                    mode="indeterminate"
                    class="circle"
                    style="margin: auto;"
                    diameter="20"
                  >
                  </mat-spinner>
                </div>

              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- pending transactions -->
        <mat-expansion-panel *ngIf="annuity?.isAMPPendingTransaction" expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text"> PENDING TRANSACTIONS</mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <mat-spinner
                *ngIf="pendingTransactionLoading"
                mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading"
                diameter="20"
              >
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div style="font-size: 12px;">
            <div class="panel-body">
              <!-- <div style="display: flex;">
                <app-refresh-button
                  style="margin-left: auto;"
                  [spinnerRotate]="isAMPItemLoading"
                  (refreshCallBack)="fetchAMPItemsView()"
                ></app-refresh-button>
              </div> -->
              <div *ngIf="pendingTransactions?.length && !pendingTransactionLoading">
                <!-- <h6 class="red-text nce-migration-indicator" *ngIf="details?.customer?.out_status == 'SY'">
                  Subscription refresh in progress
                </h6> -->

                <!-- <div class="mTable-header">
                  <div class="row filter-wrapper">
                    <div class="col-md-3" style="padding-bottom: 1.25em;">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" 
                          (keyup)="applySubListFilter($event)">
                      </div>
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div> -->
                <div class="mTable">
                  <div *ngIf="pendingTransactions?.length">
                    <table class="table" mat-table [dataSource]="pendingTransactionsTableDataSource" style="margin-bottom: unset;">
                      <!-- Reference Id Column -->
                      <ng-container matColumnDef="referenceId">
                        <th mat-header-cell *matHeaderCellDef class="table-cell"> REFERENCE ID </th>
                        <td class="push-left-75 table-cell" mat-cell *matCellDef="let pt">
                          <div  class="description">
                            <span>{{ pt?.referenceId }}</span>
                          </div>
                        </td>
                      </ng-container>

                      <!-- Creation Date Column -->
                      <ng-container matColumnDef="creationDate">
                        <th 
                          mat-header-cell *matHeaderCellDef
                          class="table-cell" 
                          style="text-align: center; white-space: nowrap;" 
                        > 
                          CREATION DATE 
                        </th>
                        <td mat-cell *matCellDef="let pt;" style="text-align: center;" class="align-top table-cell">
                          <span> {{ pt?.creationDate | date: 'dd/MM/yyyy h:mm a' }} </span>
                        </td>
                      </ng-container>

                      <!-- Expiry Date Column -->
                      <ng-container matColumnDef="expiryDate">
                      <th 
                        mat-header-cell *matHeaderCellDef
                        class="table-cell" 
                        style="text-align: center; white-space: nowrap;" 
                      > 
                        EXPIRY DATE 
                      </th>
                      <td mat-cell *matCellDef="let pt;" style="text-align: center;" class="align-top table-cell">
                        <span> {{ pt?.expiryDate | date: 'dd/MM/yyyy h:mm a'}} </span>
                      </td>
                      </ng-container>

                      <!-- QTY Column -->
                      <ng-container matColumnDef="quantity">
                        <th
                          *matHeaderCellDef
                          mat-header-cell
                          class="table-cell"
                          style="text-align: right;"
                        >
                          QUANTITY
                        </th>
                        <td mat-cell *matCellDef="let pt;"
                            class="align-top table-cell" style="text-align: right;">
                            <span> {{ pt?.quantity }} </span>
                        </td>
                      </ng-container>

                      <!-- Product Name Column -->
                      <ng-container matColumnDef="productName">
                        <th
                          *matHeaderCellDef
                          mat-header-cell
                          class="table-cell"
                          style="text-align: center;"
                        >
                          PRODUCT NAME
                        </th>
                        <td mat-cell *matCellDef="let pt;"
                            class="align-top table-cell" style="text-align: center;">
                            <span> {{ pt?.productName }} </span>
                        </td>
                      </ng-container>

                      <!-- Manage Button Column -->
                      <ng-container matColumnDef="manageBtn">
                        <th mat-header-cell *matHeaderCellDef class="table-cell"></th>
                        <td mat-cell *matCellDef="let pt;" class="align-center table-cell">
                            <button
                                class="button button-red button-round"
                            >Accept
                            </button>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="pendingTransactionDisplayedColumns;sticky:true"></tr>
                      <tr mat-row *matRowDef="let row; columns: pendingTransactionDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- order history -->
        <mat-expansion-panel expanded="false" (opened)="openGetOrderHistory()">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">ORDER HISTORY {{ orderHistoryDateFromText }}</mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <mat-spinner
                *ngIf="orderHistoryLoading"
                mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading"
                diameter="20"
              >
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div style="font-size: 12px;">
            <div class="panel-body">
              <!-- <div style="display: flex;">
                <app-refresh-button
                  style="margin-left: auto;"
                  [spinnerRotate]="isAMPItemLoading"
                  (refreshCallBack)="fetchAMPItemsView()"
                ></app-refresh-button>
              </div> -->
              <div *ngIf="orderHistory?.length">
                <!-- <h6 class="red-text nce-migration-indicator" *ngIf="details?.customer?.out_status == 'SY'">
                  Subscription refresh in progress
                </h6> -->

                <div class="mTable-header">
                  <div class="row filter-wrapper">
                    <div class="col-md-3" style="padding-bottom: 1.25em;">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" 
                          (keyup)="applyOrderHistoryFilter($event)">
                      </div>
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div>
                <div class="mTable">
                  <div *ngIf="orderHistory?.length" style="max-height: 500px; overflow-y: scroll;">
                    <table class="table" mat-table [dataSource]="orderHistoryTableDataSource" style="margin-bottom: unset;">
                      <!-- Order Date Column -->
                      <ng-container matColumnDef="orderDate">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style = "text-align: left;">ORDER DATE</th>
                        <td class="push-left-75 table-cell" mat-cell *matCellDef="let pt">
                          <div  class="description">
                            <span>{{ pt?.creationDate | date: 'dd/MM/yyyy h:mm a'  }}</span>
                          </div>
                        </td>
                      </ng-container>
                      <!-- Customer Reference Column-->
                      <ng-container matColumnDef="customerReference">
                        <th mat-header-cell *matHeaderCellDef class="table-cell" style = "text-align: left;">CUSTOMER REFERENCE</th>
                        <td class="push-left-75 table-cell" style = "text-align: left;" mat-cell *matCellDef="let pt">
                          <div  class="description">
                            <span>{{ pt?.externalReferenceId}}</span>
                          </div>
                        </td>
                      </ng-container>

                      <!-- Order Type Column -->
                      <ng-container matColumnDef="orderType">
                        <th 
                          mat-header-cell *matHeaderCellDef
                          class="table-cell" 
                          style="text-align: left; white-space: nowrap;" 
                        > 
                          ORDER TYPE 
                        </th>
                        <td mat-cell *matCellDef="let pt;" style="text-align: left;" class="align-top table-cell">
                          <span> {{ pt?.orderType }} </span>
                        </td>
                      </ng-container>

                      <!-- Stock Code Column -->
                      <ng-container matColumnDef="stockCode">
                      <th 
                        mat-header-cell *matHeaderCellDef
                        class="table-cell" 
                        style="text-align: left; white-space: nowrap;" 
                      > 
                        STOCK CODE
                      </th>
                      <td mat-cell *matCellDef="let pt;" style="text-align: left;" class="align-top table-cell">
                        <span> {{ pt?.offerId }} </span>
                      </td>
                      </ng-container>

                      <!-- Stock Description Column -->
                      <ng-container matColumnDef="stockDescription">
                        <th
                          *matHeaderCellDef
                          mat-header-cell
                          class="table-cell"
                          style="text-align: left;"
                        >
                          STOCK DESCRIPTION
                        </th>
                        <td mat-cell *matCellDef="let pt;"
                            class="align-top table-cell" style="text-align: left;">
                            <span> {{ pt?.stockDescription }} </span>
                        </td>
                      </ng-container>

                      <!-- Qty Column -->
                      <ng-container matColumnDef="qty">
                        <th
                          *matHeaderCellDef
                          mat-header-cell
                          class="table-cell"
                          style="text-align: right;"
                        >
                          QTY
                        </th>
                        <td mat-cell *matCellDef="let pt;"
                            class="align-top table-cell" style="text-align: right;">
                            <span> {{ pt?.quantity }} </span>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="orderHistoryDisplayedColumns;sticky:true"></tr>
                      <tr mat-row *matRowDef="let row; columns: orderHistoryDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col button-center" style="margin-bottom: 20px;">
                  <button
                    [disabled]="orderHistoryLoading"
                    class="button button-red button-large button-center-left"
                    (click)="orderHistoryLoadMore()"
                  >
                    Load More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

      </mat-accordion>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
